// web/src/components/metrics/DiamondPlanTotalCard.jsx
import React from "react";

export default function DiamondPlanTotalCard({ users = 0, revenue = 0 }) {
  const safeUsers = Number(users || 0);
  const safeRevenue = Number(revenue || 0);

  return (
    <div className="metric-card">
      <span className="metric-label">Usuários One Love Diamond</span>
      <span className="metric-value">{safeUsers}</span>

      <ul>
        <li>
          <span>Receita (mês)</span>
          <span>
            R$ {safeRevenue.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
          </span>
        </li>
      </ul>

      <span className="metric-tag">total por plano</span>
    </div>
  );
}
